import { createSubscriber } from './create-subscriber.js';

/**
 *
 */
export class ReactiveValue {
	#fn;
	#subscribe;

	/**
 *
 *
 *
 */
	constructor(fn, onsubscribe) {
		this.#fn = fn;
		this.#subscribe = createSubscriber(onsubscribe);
	}

	get current() {
		this.#subscribe();
		return this.#fn();
	}
}
